import React from "react";

function joinClasses(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ResultViewHeaderStatusLine({ statusLine, className = "" }) {
  if (!statusLine?.text) {
    return null;
  }

  const textClassName =
    statusLine.tone === "pending" ? "text-greyscale-3" : "text-typography";

  return (
    <div
      className={joinClasses(
        "flex min-w-0 items-center justify-end",
        className,
      )}
      aria-label={statusLine.accessibleLabel || undefined}
    >
      <p
        className={joinClasses(
          "min-w-0 text-right text-sm font-medium leading-relaxed",
          textClassName,
        )}
      >
        {statusLine.text}
      </p>
    </div>
  );
}

export function ResultViewHeader({
  title,
  recordingTime,
  icon = null,
  statusLine = null,
}) {
  const time = recordingTime?.time || "";
  const date = recordingTime?.date || "";
  const timestamp = [time, date].filter(Boolean).join(" ");

  return (
    <div className="flex flex-col w-full h-fit items-start text-left gap-0.5">
      <div className="flex items-center gap-2">
        {icon ? (
          <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary [&_svg]:h-6 [&_svg]:w-auto [&_svg]:fill-current [&_svg]:stroke-current">
            {icon}
          </span>
        ) : null}
        <h1 className="subtitle-text">{title}</h1>
      </div>
      {timestamp && statusLine?.text ? (
        <div className="flex w-full items-center justify-between gap-3">
          <p className="muted-text shrink-0">{timestamp}</p>
          <ResultViewHeaderStatusLine statusLine={statusLine} />
        </div>
      ) : timestamp ? (
        <p className="muted-text">{timestamp}</p>
      ) : (
        <ResultViewHeaderStatusLine statusLine={statusLine} />
      )}
    </div>
  );
}

function ResultViewScaffold({
  title,
  recordingTime,
  icon = null,
  statusLine = null,
  children,
  details = null,
  footer = null,
  outerClassName = "",
  summaryClassName = "",
}) {
  return (
    <div
      className={joinClasses(
        "w-full max-w-lg h-full min-h-0 overflow-y-auto",
        outerClassName,
      )}
    >
      <section className="min-h-fit p-4 pt-0 sm:pt-4 flex flex-col items-stretch gap-4">
        <div
          className={joinClasses(
            "w-full h-fit flex flex-col gap-4 justify-start items-stretch text-left",
            summaryClassName,
          )}
        >
          <ResultViewHeader
            title={title}
            recordingTime={recordingTime}
            icon={icon}
            statusLine={statusLine}
          />
          {children}
        </div>
      </section>

      {details}

      {footer ? <div className="w-full p-4 pt-0">{footer}</div> : null}
    </div>
  );
}

export default ResultViewScaffold;
